import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs"

export default class extends Controller {
  static targets = ["createTagForm", "rangePreview", "toggleButton", "highlightableWapper", "tagsList"]

  connect() {
    this.click_in = 0;
    this.selected_text = "";
    this.outOfRangeSelectedText = "";
    const thisController = this;

    document.addEventListener("mousedown",(event) => {
      if (
        (thisController.element.contains(event.target) && event.target.classList.contains("highlightable"))
        || thisController.createTagFormTarget.contains(event.target)
      ) {
        // CLICK INSIDE HIGHLIGHTABLE TEXT
        thisController.click_in = event.target;
      } else if (thisController.element.contains(event.target) && event.target.classList.contains("tag-instance-range")) {
        // CLICK HIGHLIGHTED TEXT
        thisController.resetPopup();
        thisController.click_in = event.target;
      } else {
        // CLICK OUTSIDE HIGHLIGHTABLE TEXT
        thisController.resetPopup();
      }
    })

    document.addEventListener("mouseup",(event) => {
      let selection = document.getSelection();
      let selectionString = selection.toString();
      
      if (
            thisController.element.contains(event.target)
         && thisController.click_in === event.target && selectionString.length > 0
         && event.target.classList.contains("highlightable")
         && thisController.outOfRangeSelectedText != selectionString
      ) {
        // AFTER HIGHLIGHT
        // Get range start and end index
        const indexes = thisController.getRangeIndexes(selection, selectionString)
        // Fill tags forms with new tag data
        thisController.updatePopupForms(indexes["start"], indexes["end"], selectionString);
        thisController.updatePopupDeleteButtons()
        thisController.initializePopup(selectionString);

      } else if (thisController.click_in == event.target && thisController.click_in.classList.contains("tag-instance-range")) {
        // AFTER TAG CLICK
        // Get Tag data from html <span> class
        const startIndex = /tag-instance-start-(\d+)/g.exec(thisController.click_in.classList.value)[1];
        const endIndex = /tag-instance-end-(\d+)/g.exec(thisController.click_in.classList.value)[1];
        const selectionString = thisController.click_in.innerText;
        const tagInstanceIds = /tag-instance-ids([-\d]+)/g.exec(thisController.click_in.classList.value)[1].split("-").filter(id => id != '');
        const tagIds = /tag-ids([-\d]+)/g.exec(thisController.click_in.classList.value)[1].split("-").filter(id => id != '');

        // Fill tags forms with new tag data
        thisController.updatePopupForms(startIndex, endIndex, selectionString);
        // Fill tags delete button with new data and display them
        thisController.updatePopupDeleteButtons(tagInstanceIds, tagIds)
        thisController.initializePopup(thisController.click_in.innerText)
      } else if (thisController.createTagFormTarget.contains(event.target)) {
        // AFTER CLICK IN POPUP
        // do nothing
      } else {
        // CLICK OR HIGHLIGHT OUT OF RANGE
        thisController.outOfRangeSelectedText = selectionString;
        thisController.resetPopup();
      }
    })
  }

  getRangeIndexes(selection, selectionString) {
    const anchorChildIndex = [...selection.anchorNode.parentNode.childNodes].indexOf(selection.anchorNode);
    const focusChildIndex = [...selection.focusNode.parentNode.childNodes].indexOf(selection.focusNode);
    let highlightStart = null;
    let highlightStartNode = null;
    let lineBreakPadding = 0;


    if (anchorChildIndex != focusChildIndex) {
      highlightStartNode = anchorChildIndex < focusChildIndex ? selection.anchorNode : selection.focusNode;
      highlightStart = anchorChildIndex < focusChildIndex ? selection.anchorOffset : selection.focusOffset;
      lineBreakPadding = (Math.abs(anchorChildIndex - focusChildIndex)/3);
    } else { // same Node
      highlightStartNode = selection.anchorNode
      highlightStart = selection.anchorOffset < selection.focusOffset ? selection.anchorOffset : selection.focusOffset;
    }

    
    let preNodeCharCount = 0;
    // Find number of chars in previous DOM element
    let previousSibling = highlightStartNode.parentElement.previousElementSibling;
    while (previousSibling != null) {
      preNodeCharCount += previousSibling.textContent.length;
      previousSibling = previousSibling.previousElementSibling;
    }

    // Find number of chars in current DOM element
    let previousInnerSibling = highlightStartNode.previousSibling;
    while (previousInnerSibling != null) {
      preNodeCharCount += previousInnerSibling.textContent.length;
      previousInnerSibling = previousInnerSibling.previousSibling;
    }

    const numberOfLineBefore = (anchorChildIndex < focusChildIndex ? anchorChildIndex : focusChildIndex)/3;

    const startIndex = highlightStart + preNodeCharCount + numberOfLineBefore;
    const endIndex = startIndex + selectionString.length - lineBreakPadding;
    return {"start": startIndex, "end": endIndex}
  }

  resetPopup() {
    this.click_in = 0;
    this.createTagFormTarget.classList.add("d-none");
    this.selected_text = "";
    this.rangePreviewTarget.innerText = "";
    this.createTagFormTarget.querySelectorAll(`[data-tagid]`).forEach((link) => {link.classList.add("d-none")})
  }

  updatePopupForms(startIndex, endIndex, selectionString) {
    const start_indexes =  this.createTagFormTarget.querySelectorAll("#tag_instance_start_index");
    const end_indexes =    this.createTagFormTarget.querySelectorAll("#tag_instance_end_index");
    const text_inputs =    this.createTagFormTarget.querySelectorAll("#tag_instance_text");

    start_indexes.forEach((input) => {input.value = startIndex})
    end_indexes.forEach((input) =>   {input.value = endIndex})
    text_inputs.forEach((input) =>   {input.value = selectionString})
  }

  updatePopupDeleteButtons(tagInstanceIds=null, tagIds=null) {
    this.toggleButtonTargets.forEach((button) => {
      button.checked = false;
    })

    if (tagInstanceIds != null && tagIds != null) {
      tagInstanceIds.forEach((id, i) => {
        const link = this.createTagFormTarget.querySelector(`[data-linktagid="${tagIds[i]}"]`)
        const previousId = /tag_instances\/\d+/g.exec(link.href)[0]
        link.href = link.href.replace(previousId, `tag_instances/${id}`)

        const toggle = this.createTagFormTarget.querySelector(`[data-tagid="${tagIds[i]}"]`);
        toggle.checked = true
      })
    }
  }

  initializePopup(selection) {
    this.selected_text = selection;
    this.rangePreviewTarget.innerText = selection;
    this.createTagFormTarget.classList.remove("d-none");
  }

  listTags(tags) {
    this.tagsListTarget.innerHTML = ""
    tags.forEach((tag) => {
      const div = document.createElement("div");
      div.innerText = tag["name"];
      div.classList = `mr-3 my-3 p-2 badge border-highlight bg-highlight-${tag["color"]}`;
      this.tagsListTarget.appendChild(div);
    })
  }

  toggle(event) {
    const action = event.target.checked ? "add" : "delete";
    const tagElement = event.target.parentElement.parentElement;
    const thisController = this;
    const link = tagElement.querySelector("a");

    if (action == "delete") {
      link.addEventListener('ajax:success', (customEvent) => {
        const response = customEvent.detail[0];
        thisController.highlightableWapperTarget.innerHTML = response.html;
        thisController.listTags(response.tags);
      })
      link.click();

    } else if (action == "add") {
      const form = tagElement.querySelector("form");
      form.addEventListener('ajax:success', (customEvent) => {
        const response = customEvent.detail[0];
        thisController.highlightableWapperTarget.innerHTML = response.html;
        const previousId = /tag_instances\/\d+/g.exec(link.href)[0]
        link.href = link.href.replace(previousId, `tag_instances/${response.tag_instance_id}`)
        thisController.listTags(response.tags);
      })
      Rails.fire(form, "submit");
    }
  }
}
